import { CampaignMode, CampaignType } from '../interfaces/campaign';
import { AdPageType } from '../interfaces/pages';

export function getBreadcrumbs(path: string): string[] {
	return path.replace(/^\/|\/$/g, '').split('/');
}

export const isCampaignCreateMode = (mode: CampaignMode) => {
	return mode === 'create';
};

export const isCampaignAdvertisingType = (type: CampaignType) => {
	return type === 'advertising';
};

export const isOrderedAdType = (type: AdPageType) => {
	return type === 'ordered-ad';
};

export const getInitials = (name: string): string => {
	if (!name) {
		return '';
	}
	return name
		.split(' ')
		.map(word => word[0]?.toUpperCase())
		.join('');
};
